import { ImageField, StringField, THeadingTag } from '../../../types/types';
import { TextModuleFields, TextModuleParams, TextModuleProps } from '../types/textModule.types';

import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { LinkField } from '@sitecore-jss/sitecore-jss-react/types/components/Link';
import { TImageField } from '../../../types/sitecore.types';

export class TextModuleModel {
  private readonly fields?: TextModuleFields;
  private readonly rendering?: ComponentRendering;
  private readonly params?: TextModuleParams;

  constructor(props: TextModuleProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
    this.params = props?.params;
  }

  get bodyText(): StringField | undefined {
    return this.fields?.bodyText;
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get subtitle(): StringField | undefined {
    return this.fields?.subtitle;
  }

  get link1(): LinkField | undefined {
    return this.fields?.primaryLink;
  }

  get link2(): LinkField | undefined {
    return this.fields?.secondaryLink;
  }

  get validLink2Exists(): boolean {
    return !!(this.link2?.value?.text && this.link2?.value?.href);
  }

  get downloadButtonLink(): LinkField | undefined {
    return this.fields?.downloadButtonLink;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get mobileImage(): ImageField | undefined {
    return this.fields?.mobileImage;
  }

  getLoadedImageDimension(isDesktop: boolean): { imageWidth: number } {
    let imageWidth = 0;

    let imageLoaded: TImageField | undefined = {};
    if (isDesktop) {
      imageLoaded = this?.image?.value?.src ? this.image : this.mobileImage;
    } else {
      imageLoaded = this?.mobileImage?.value?.src ? this.mobileImage : this.image;
    }
    imageWidth = Number(imageLoaded?.value?.width) || 0;
    return { imageWidth };
  }

  get textPosition(): StringField | undefined {
    return this.fields?.alignment?.fields?.Key;
  }

  get backgroundColor(): StringField | undefined {
    return this.fields?.backgroundColor?.fields?.Key;
  }

  get textColor(): string | undefined {
    return this.fields?.textColors?.fields?.Key?.value?.toLowerCase();
  }

  get primaryCtaColor(): string | undefined {
    return this.fields?.primaryCtaColors?.fields?.Key?.value?.toLowerCase();
  }

  get secondaryCtaColor(): string | undefined {
    return this.fields?.secondaryCtaColors?.fields?.Key?.value?.toLowerCase();
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h3';
  }

  get dataSource(): string | undefined {
    return this.rendering?.dataSource;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
